<template>
    <div class="h-chart">
        <div :id="id" class="chart" :style="height?{height: height }:''"></div>
    </div>
</template>

<script>
    import HighCharts from 'highcharts/highstock';
    import HighChartsMore from 'highcharts/highcharts-more';
    import HighCharts3D from 'highcharts/highcharts-3d';
    import HighChartsNoData from 'highcharts/modules/no-data-to-display';
    HighChartsMore(HighCharts);
    HighCharts3D(HighCharts)
    HighChartsNoData(HighCharts)

    // 无数据时：去掉绘图区背景，并把「暂无数据」文案居中到整个图表区域
    HighCharts.addEvent(HighCharts.Chart, 'render', function () {
        if (!this.hasData() && this.plotBackground) {
            this.plotBackground.attr({fill: 'none'});
        }
        if (!this.noDataLabel) {
            return;
        }
        const label = this.noDataLabel;
        const bbox = label.getBBox();
        // 置为未定位，让 align 直接写坐标，避免文案出现位移动画
        label.placed = false;
        label.align({
            align: 'center',
            verticalAlign: 'middle',
            x: 0,
            y: 0,
            width: bbox.width,
            height: bbox.height
        }, false, {
            x: 0,
            y: 0,
            width: this.chartWidth,
            height: this.chartHeight
        });
    });
    export default {
        name: "HChart",
        props: {
            id: {
                type: String
            },
            options: {
                type: Object
            },
            height: {
              type: String
            },
            stock: {
              type: Boolean,
              default: false
            },
            wheelZoom: {
              type: Boolean,
              default: false
            }
        },
        data() {
            return {
                chart: null,
                wheelZoomHandler: null
            }
        },
        methods:{
            drawChart(){
                this.destroyWheelZoom();
                if (this.chart) {
                    this.chart.destroy();
                }
                const render = this.stock ? HighCharts.stockChart : HighCharts.chart;
                this.chart = render(this.id, this.options);
                this.bindWheelZoom();
            },
            redraw(){
                this.drawChart()
            },
            bindWheelZoom(){
                if (!this.wheelZoom || !this.chart || !this.chart.container) {
                    return;
                }
                this.wheelZoomHandler = (event) => {
                    const chart = this.chart;
                    const xAxis = chart && chart.xAxis && chart.xAxis[0];
                    if (!xAxis) {
                        return;
                    }
                    const dataMin = xAxis.dataMin !== undefined ? xAxis.dataMin : 0;
                    const dataMax = xAxis.dataMax !== undefined
                        ? xAxis.dataMax
                        : (xAxis.categories ? xAxis.categories.length - 1 : 0);
                    if (dataMax <= dataMin) {
                        return;
                    }
                    event.preventDefault();

                    const currentMin = xAxis.min !== undefined ? xAxis.min : dataMin;
                    const currentMax = xAxis.max !== undefined ? xAxis.max : dataMax;
                    const currentRange = currentMax - currentMin;
                    if (currentRange <= 0) {
                        return;
                    }

                    const pointer = chart.pointer.normalize(event);
                    const plotRatio = Math.min(
                        Math.max((pointer.chartX - chart.plotLeft) / chart.plotWidth, 0),
                        1
                    );
                    const center = currentMin + currentRange * plotRatio;
                    const minRange = xAxis.options.minRange || 1;
                    const fullRange = dataMax - dataMin;
                    const scale = event.deltaY < 0 ? 0.8 : 1.25;
                    const nextRange = Math.max(minRange, currentRange * scale);

                    if (nextRange >= fullRange) {
                        xAxis.setExtremes(dataMin, dataMax, true, false);
                        return;
                    }

                    let nextMin = center - nextRange * plotRatio;
                    let nextMax = center + nextRange * (1 - plotRatio);

                    if (nextMin < dataMin) {
                        nextMax += dataMin - nextMin;
                        nextMin = dataMin;
                    }
                    if (nextMax > dataMax) {
                        nextMin -= nextMax - dataMax;
                        nextMax = dataMax;
                    }
                    xAxis.setExtremes(nextMin, nextMax, true, false);
                };
                this.chart.container.addEventListener("wheel", this.wheelZoomHandler, {
                    passive: false
                });
            },
            destroyWheelZoom(){
                if (this.chart && this.chart.container && this.wheelZoomHandler) {
                    this.chart.container.removeEventListener("wheel", this.wheelZoomHandler);
                }
                this.wheelZoomHandler = null;
            }
        },
        mounted() {
            HighCharts.setOptions({
                lang:{
                    resetZoom: '重置缩放',
                    noData: '暂无数据'
                },
                noData: {
                    style: {
                        fontWeight: '400',
                        fontSize: '14px',
                        color: '#999999'
                    }
                }
            });
            this.drawChart()
        },
        watch: {
            options: {
                handler() {
                    this.drawChart();
                }
            },
            stock() {
                this.drawChart();
            },
            wheelZoom() {
                this.drawChart();
            },
        },
        beforeDestroy() {
            this.destroyWheelZoom();
            if (this.chart) {
                this.chart.destroy();
            }
        },
    }
</script>

<style scoped>

</style>
